/**
 * resolves value of the current var css
 * example: var(--some-color) -> #abcdef
 * needed for example for the echarts lib which doesn't resolve the var(...) format
 */
export function cssVar(name: string): string {
  return getComputedStyle(document.documentElement).getPropertyValue(name);
}
